import React from 'react';
import { sendClick } from 'reaxl-analytics';
import { Link } from '@argo/ui-elements';
import { FlexBox, size, breakpoints } from '@argo/principles';
import styled from '@emotion/styled';

const StepsSection = styled(FlexBox)`
  padding: 48px ${size.lg}px;
  .first {
    padding: 0 128px 0 0;
    @media (min-width: ${breakpoints.xl + 1}px) and (max-width: ${breakpoints.max}px) {
      padding: 0;
      margin-right: ${size.lg}px;
    }
    @media (max-width: ${breakpoints.xl}px) {
      padding: 0;
    }
  }

  .second {
    padding: 0 128px 0 0;
    @media (min-width: ${breakpoints.xl + 1}px) and (max-width: ${breakpoints.max}px) {
      padding: 0;
      margin-right: ${size.lg}px;
    }
    @media (max-width: ${breakpoints.xl}px) {
      padding: 0;
    }
  }
`;

export default function ShoppingStepsSection() {
  const onFinancingClick = (event: any) => {
    sendClick('psxVDPFinanceClick', event);
  };

  const onVehicleServiceContractClick = (event: any) => {
    sendClick('psxVDPVehicleServiceContractsClick', event);
  };

  const onGapInsuranceClick = (event: any) => {
    sendClick('psxVDPGapInsuranceClick', event);
  };

  return (
    <StepsSection className="steps-section" justifyContent="center" style={{ margin: '0px' }}>
      <FlexBox className="step-item first">
        <div className="step-number">1</div>
        <div style={{ margin: '8px 0px 0px 0px' }}>
          <h2>Discover Trustworthy Sellers</h2>
          <p>Explore a world of trusted sellers on Private Seller Exchange and unlock secure shopping, seamless test drives, and irresistible deals.</p>
        </div>
      </FlexBox>
      <FlexBox className="step-item second">
        <div className="step-number">2</div>
        <div style={{ margin: '8px 0px 0px 0px' }}>
          <h2>Shop Confidently</h2>
          <p className="step-description">Leverage Kelley Blue Book&apos;s expertise for accurate car valuation. Seamlessly complete your purchase online, offering multiple payment options.</p>
          <div>
            <Link
              href="https://www.autotrader.com/marketplace/financing"
              label="Financing"
              target="_blank"
              onClick={(event: any) => onFinancingClick(event)}
              rel="nofollow"
            >
              Financing
            </Link>
            ,
            {' '}
            <Link
              href="https://www.autotrader.com/marketplace/vehicle-service-contracts"
              label="vehicle service contracts"
              target="_blank"
              onClick={(event: any) => onVehicleServiceContractClick(event)}
              rel="nofollow"
            >
              vehicle service contracts
            </Link>
            <b>, and</b>
            {' '}
            <Link
              href="https://www.autotrader.com/marketplace/gap-insurance"
              label="GAP Insurance"
              target="_blank"
              onClick={(event: any) => onGapInsuranceClick(event)}
              rel="nofollow"
            >
              GAP Insurance
            </Link>
            {' '}
            <b>available.</b>
          </div>
        </div>
      </FlexBox>
      <FlexBox className="step-item last">
        <div className="step-number">3</div>
        <div style={{ margin: '8px 0px 0px 0px' }}>
          <h2>Take the Wheel and Drive</h2>
          <p>Choose your preferred option: collect your car from the seller or enjoy doorstep delivery. Let us handle the necessary paperwork, with ease.</p>
        </div>
      </FlexBox>
    </StepsSection>
  );
}
